// Home page entry — composes the page from independent feature modules.
// Non-hero motion lives in ./motion.js; the hero uses the cinematic entrance
// (./cinematic-hero.js) that replaces the old heroEntrance.

import { initVideoHero } from './video-hero'; // playback (loop at 5.2667s)
import { initCinematicHero } from './cinematic-hero'; // scale-free video + navbar/header cascade
import { initCompaniesMarquee } from '../../components/companies-marquee';
import { initHpChallenge } from './hp-challenge';
import { initHpAcquireCard } from './hp-acquire-card';
import { initSwiperCsWithResize } from './swiper-cs';
import { initNumberAnim } from '../../components/number-anim';
import { acquireEntrance, sectionReveals } from './motion';

// ─── Hero: playback + cinematic entrance (replaces the old heroEntrance) ─────
initVideoHero();
initCinematicHero();

// ─── Non-motion features ──────────────────────────────────────────────────────
initCompaniesMarquee();
initSwiperCsWithResize();
initHpAcquireCard();

// ─── Scroll-pinned card stack (custom interaction, not a generic reveal) ─────
initHpChallenge();

// ─── Number counter (scroll-triggered, but tied to specific markup attr) ─────
initNumberAnim();

// ─── Rest of the page motion (Acquire entrance + section reveals) ────────────
acquireEntrance();
sectionReveals();
